import Agent from './agent'

// 处理风控数据
// https://km.sankuai.com/page/1287108773
enum RISK_CONTROL_APP {
  default = 216,
  meituan = 0,
  dianping = 11,
  phx = 30,
}
export function getApp() {
  if (Agent.meituan || Agent.group_wxapp) return RISK_CONTROL_APP.meituan
  if (Agent.dianping || Agent.dianping_wxapp) return RISK_CONTROL_APP.dianping
  if (Agent.phx || (Agent.appnm.indexOf('phoenix') !== -1 && Agent.anyminiprogram)) {
    return RISK_CONTROL_APP.phx
  }
  return RISK_CONTROL_APP.default
}

export function getPlatform() {
  if (Agent.native && Agent.android) return 4
  if (Agent.native && Agent.iphone) return 5
  if (Agent.weixin) return 11
  if (Agent.miniprogram) return 13
  if (Agent.pc) return 1
  return 3
}
